Modernizr.load({
    test: Modernizr.placeholder,
    nope: 'js/jquery.placeholder.js',
    complete: function() {
        $('input, textarea').placeholder();
    }
});